<div [class]="getAlignClass()" [class.readonly]="readOnly"
    [class.disabled]="disabled" [class.alternative]="alternativeStyle">
    <div (click)="check()" class="app-radio-indicator" [class.active]="checked"
        [class.multiple]="multiple">
        <svg-icon src="assets/images/icon-check.svg"
            class="app-radio-icon"></svg-icon>
    </div>
    <ng-content></ng-content>
</div>